module.exports = __webpack_public_path__ + "static/bg-sidebar-grade-calculators-9b87de7a4e3b4e0e5916ad11a7652bce.svg";